import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import VehicleVehicleOperationsScreen from "../../../container/Vehicles/VehicleVehicleOperationsScreen";
import CreateVehicleVehicleOperations from "../../../container/Vehicles/VehicleVehicleOperationsScreen/CreateVehicleVehicleOperations";

const VehicleOperationRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_VEHICLEOPERATIONS.HOME}
          element={<VehicleVehicleOperationsScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.VEHICLE_VEHICLEOPERATIONS.CREATE}
          element={<CreateVehicleVehicleOperations />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.VEHICLE_VEHICLEOPERATIONS.EDIT}
          element={<CreateVehicleVehicleOperations isEdit={true} />}
        />
      )}
    </>
  );
};

export default VehicleOperationRoutes;
